import React from "react";
import CustomPicky from "./CustomPicky";

const ApprovalStatusMultiSelect = ({
  approvalStatus,
  onSelectApprovalStatus,
}) => {
  const options = [
    { label: "All", value: -1 },
    { label: "Approved", value: 2 },
    { label: "Declined", value: 3 },
    { label: "Pending", value: 1 },
  ];

  return (
    <CustomPicky
      key={`approval-${approvalStatus?.value || "none"}`}
      options={options}
      value={approvalStatus}
      multiple={false}
      onChange={(val) => onSelectApprovalStatus(val)}
      placeholder="Select status"
    />
  );
};

export default ApprovalStatusMultiSelect;
